import router from "@/routes";
import store from "@/stores";

// state
const threshold = 4320 * 60 * 1000; //4320 min = 72 hrs
let lastActivity = new Date();

// activity monitor
(function() {
  var current = window.onmousemove;
  window.onmousemove = function() {
    lastActivity = new Date();
    if (current) current.apply(undefined, arguments);
  };
})();

// features
function isActive() {
  return new Date() - lastActivity < threshold;
}

function isInactive() {
  return new Date() - lastActivity > threshold;
}

function isAuthenticated() {
  return store.getters["cognito/isAuthenticated"];
}

function signOutIfInactive() {
  if (isInactive() && isAuthenticated()) {
    router.push("/signout");
  }
}

// interval
setInterval(() => signOutIfInactive(), 30 * 1000);

// exports
export default {
  isActive,
  isInactive,
};
